module.exports = __webpack_public_path__ + "img/工业互联网图.721cc991.png";